import { post } from "../AxiosConfig";
import { withCache, requestCacheKey } from './profitabilityCache';

const URI = "/employee";

const listEmployeeCached = withCache(
  (payload, config = {}) => post(URI + '/list-employee', payload, config),
  payload => requestCacheKey('employees', payload),
);

// Full edit records stay fresh; only reusable employee lists are cached.
const listEmployee = (payload, config = {}) => payload?.id
  ? post(URI + '/list-employee', payload, config)
  : listEmployeeCached(payload, config);

const listWithdrawal = (payload) => {
  const URL = `${URI}/withdraw-information`;
  return post(URL, payload);
};

const listAgent = (payload) => {
  const URL = `${URI}/list-agent`;
  return post(URL, payload);
};

const listAssociate = (payload) => {
  const URL = `${URI}/location-information`;
  return post(URL, payload);
};

const listNotAssociate = (payload) => {
  const URL = `${URI}/notassociate-location`;
  return post(URL, payload);
};

const updateEmployee = (payload) => {
  const URL = `${URI}/update-employee`;
  return post(URL, payload);
};

const deleteEmployee = (payload) => {
  const URL = `${URI}/delete-employee`;
  return post(URL, payload);
};

const empAffiliateLocation = (payload) => {
  const URL = `${URI}/add-employee-locationdetail`;
  return post(URL, payload);
};

const bankAffiliation = (payload) => {
  const URL = `${URI}/add-employee-bankdetail`;
  return post(URL, payload);
};

const bankAffiInfo = (payload) => {
  const URL = `${URI}/bank-information`;
  return post(URL, payload);
};

const chargesList = (payload) => {
  const URL = `${URI}/loading-machine-information`;
  return post(URL, payload);
};

const EmployeeService = {
  listEmployee,
  listAgent,
  listAssociate,
  listNotAssociate,
  bankAffiliation,
  bankAffiInfo,
  empAffiliateLocation,
  updateEmployee,
  deleteEmployee,
  listWithdrawal,
  chargesList,
};

export default EmployeeService;
